import { Component, ViewChild, NgZone, Renderer2, ElementRef, AfterViewInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Media } from '../interfaces/media';
import { ProgramsService } from '../services/programs.service';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { PopoverController } from '@ionic/angular';
import { ProgramDetailsComponent } from '../components/program-details/program-details.component';
import { Programs } from '../interfaces/programs';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
})
export class PlayerComponent implements AfterViewInit  {
  @ViewChild('myAudio', {static: false}) audioPlayer: ElementRef;
  @ViewChild('myAudio', {static: false}) myAudio: ElementRef<HTMLAudioElement>;
  @ViewChild('testView', {static: false}) testView: ElementRef;
  @Output() itemChange = new EventEmitter();
  @HostListener('contextmenu', ['$event'])
    // onRightClick(event) {
    //   event.preventDefault();
    // }

  playlist: any;
  currentIndex = 0;
  curTime = 0;
  dur: number;
  programs: any;
  data: any;
  programIds: Array<any>;
  mediaPlayerTitle: string;
  elearningChannel: string;
  broadcastType: string;
  baseUrl: string;
  usergroup: string;
  channelId: number;
  apiKey: string;
  programKey: string;
  programImage: string;
  channelTitle: string;
  channelImage: string;
  shufflePrograms: string;
  shuffledPlaylist: any;
  playStatus: string;
  volumeStatus: string;
  volume: number;
  audioTrack: any;
  minutes: number;
  currentMinutes: number;
  currentSeconds: number;
  seconds: number;
  cleanCurrentTime: string;
  cleanDuration: string;
  currentItem: Programs;

  constructor(
    private sanitizer: DomSanitizer,
    public ngZone: NgZone,
    private programService: ProgramsService,
    private programApiService: ProgramsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public fontLibrary: FaIconLibrary,
    private router: Router,
    private popoverController: PopoverController,
    private renderer: Renderer2,
    public el: ElementRef) {
    this.fontLibrary.addIconPacks(fas);
    this.mediaPlayerTitle = localStorage.getItem('mediaPlayerTitle');
    this.apiKey = localStorage.getItem('APIKey');
    this.baseUrl = localStorage.getItem('baseUrl');
    // this.currentItem = {title: '', mediaFile: '', type: '', embed_code: '', live_broadcast: false, status: 'disabled', image: '', imageThumb: '', imageCheck: '', imageThumbCheck: '', description: '', author: '', storeUrl: '', broadcastType: '', rawImage: ''}
    this.currentItem = {title: '', url: '', file_type: '', embed_code: '', live_broadcast: false, status: 'disabled', image: '', imageThumb: '', imageCheck: '', imageThumbCheck: '', description: '', author: '', storeUrl: '', broadcastType: '', rawImage: ''}
    this.curTime = 0;
  }

  ngAfterViewInit() {
    this.playStatus = 'pause';
    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.data = this.router.getCurrentNavigation().extras.state.channel;
        this.channelId = this.data.id;
        this.channelTitle = this.data.title;
        this.channelImage = this.data.channelImage;
        this.shufflePrograms = this.data.randomize;
        this.elearningChannel = this.data.elearningChannel;
        this.broadcastType = this.data.broadcastType;
        this.usergroup = this.data.usergroup;
        this.playlist = [];
        this.programIds = this.data.programs.split(',');

        // PHP API SERVICE
        this.programApiService.getProgramsApi(this.channelId, this.baseUrl)
        .subscribe(res => {
          let itemList = [];
          itemList = Object.values(res);
          itemList.forEach(snap => {
            this.playlist.push({
              title: snap.title,
              url: this.serveURL(snap.url, snap.upload_url, snap.upload_directory),
              type: snap.file_type,
              broadcastType: snap.broadcast_type,
              embed_code: snap.embed_code,
              live_broadcast: snap.live_broadcast,
              status: 'disabled',
              rawImage: snap.image,
              image: this.baseUrl + snap.image,
              imageThumb: this.baseUrl + snap.image_thumb,
              imageCheck: snap.image,
              imageThumbCheck: snap.image_thumb,
              description: snap.description,
              author: snap.author,
              storeUrl: snap.store_url,
            });
          });
          
          if (this.shufflePrograms === '1') {
            this.shuffledPlaylist = this.shuffleArray(this.playlist);
            this.currentItem = this.shuffledPlaylist[ this.currentIndex ];
            this.currentItem.status = 'enabled';
            this.playStatus = 'play';
          } else {
            this.shuffledPlaylist = this.playlist;
            this.currentItem = this.shuffledPlaylist[ this.currentIndex ];
            this.currentItem.status = 'enabled';
            this.playStatus = 'play';
          }
        });

        // END PHP API SERVICE

      }
      this.volumeStatus = 'unmuted';
    });
    // const httpHeaders = new HttpHeaders({
    //   'Content-Type' : 'application/json',
    //   'Authorization': 'BASIC ' + this.apiKey
    // });
    // const options = {
    //   headers: httpHeaders
    // };
  }

  togglePlay() {
    if (this.playStatus === 'play') {
      this.pauseTrack();
    } else {
      this.playTrack();
    }
  }

  serveURL(url, uploadUrl, uploadDirectory) {
    if (url === '' || url === null) {
      return this.baseUrl + uploadDirectory + uploadUrl + '?option=com_jbackend&view=request&api_key=0RDIJ11RIFHA9HWB6PSH';
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  getCurrentTime() {
    this.curTime = this.myAudio.nativeElement.currentTime / this.myAudio.nativeElement.duration;

    const h = Math.floor(this.curTime / 3600);
    const m = Math.floor(this.curTime % 3600 / 60);
    const s = Math.floor(this.curTime % 3600 % 60);
    this.cleanCurrentTime = this.secondsToHms(this.myAudio.nativeElement.currentTime);
  }

  getDuration() {
    this.dur = this.myAudio.nativeElement.duration;
    this.cleanDuration = this.secondsToHms(this.dur);
  }

  secondsToHms(d) {
    d = Number(d);

    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
    // ('0' + h).slice(-2) + ":" + 
}

  getChannelId(channelId, channelIdsFromProg) {
    const channelIds = channelIdsFromProg.split(',');
    var result;
    if (channelIds.includes(channelId.toString())) {
      result = 1;
    } else {
      result = 0;
    }
    return result;
  }

  shuffleArray(array) {
    let m = array.length, t, i;
    // While there remain elements to shuffle
    while (m) {
      // Pick a remaining element…
      i = Math.floor(Math.random() * m--);
      // And swap it with the current element.
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
    return array;
  }

  nextTrack() {
    this.currentIndex++;
    this.currentItem = this.playlist[ this.currentIndex ];
    this.currentItem.status = 'enabled';
    this.audioPlayer.nativeElement.play();
    this.playStatus = 'play';
  }

  startOver() {
    this.audioPlayer.nativeElement.currentTime = 0;
    this.audioPlayer.nativeElement.play();
    this.playStatus = 'play';
  }

  trackEnded() {
    this.nextTrack();
  }

  playTrack() {
    this.audioPlayer.nativeElement.play();
    this.playStatus = 'play';
  }

  pauseTrack() {
    this.audioPlayer.nativeElement.pause();
    this.playStatus = 'pause';
  }

  volumeOn() {
    this.audioPlayer.nativeElement.muted = false;
    this.volumeStatus = 'unmuted';
    // if (localStorage.getItem('volume')) {
    //   this.volume = parseFloat(localStorage.getItem('volume'));
    // } else {
    //   this.volume = this.audioPlayer.nativeElement.volume;
    // }
  }

  mute() {
    this.audioPlayer.nativeElement.muted = true;
    this.volumeStatus = 'muted';
    this.volume = 0;
  }

  changeVolume(e) {
    this.audioPlayer.nativeElement.volume = e.detail.value;
    this.audioPlayer.nativeElement.muted = false;
    this.volume = this.audioPlayer.nativeElement.volume;
    if (this.volume >= .1) {
      localStorage.setItem('volume', this.volume.toString());
    }
  }

  onClickPlaylistItem(item: Programs, index) {
    if (this.broadcastType === 'ondemand' || (this.broadcastType === 'elearning' && item.status === 'enabled')) {
      this.currentIndex = index;
      this.currentItem = item;
    }
  }

  logout() {
    this.authService.logoutUser();
    this.router.navigateByUrl('login');
  }

  async getProgramDetails(title, author, description, storeUrl) {
    const popover = await this.popoverController.create({
      component: ProgramDetailsComponent,
      translucent: true,
      componentProps: {
        title: title,
        author: author,
        description: description,
        storeUrl: storeUrl
      }
    });
    return await popover.present();
  }

}
